import { DesignSystem } from '@/src/design-system'

export default function PlaidOauthReplyScreen() {
  return <DesignSystem.Loading.Screen />
}
